'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import AdFoxFactory from '../AdFox/AdFoxFactory';
import { addClassById, removeClassById } from '../../utils/browser';

class AdFoxWideScreen extends React.Component {
  constructor (props) {
    super(props);

    this.rootEl = 'top-wide-screen';

    this.addClass = this.addClass.bind(this);
    this.removeClass = this.removeClass.bind(this);
  }

  addClass () {
    addClassById('root', 'has-' + this.rootEl);
  }

  removeClass () {
    removeClassById('root', 'has-' + this.rootEl);
  }

  componentDidMount () {
    const wideScreenContainer = document.getElementById(this.rootEl);

    if (window.Ya && window.Ya.adfoxCode && wideScreenContainer) {
      const {position, dealType, realtyType} = this.props;
      const config = AdFoxFactory(this.props.regionName).getConfigBySection(position, dealType, realtyType);

      if (!config.placeId) {
        return;
      }

      try {
        window.Ya.adfoxCode.create({
          ownerId: 252085,
          containerId: this.rootEl,
          params: {
            pp: 'h',
            ps: config.regionId,
            p2: config.placeId
          },
          onRender: this.addClass,
          onStub: this.removeClass,
          onError: this.removeClass
        });
      } catch (e) {}
    }
  }

  componentWillUnmount () {
    const wideScreenContainer = document.getElementById(this.rootEl);

    if (window.Ya && window.Ya.adfoxCode && wideScreenContainer) {
      try {
        window.Ya.adfoxCode.destroy(this.rootEl);
        wideScreenContainer.innerHTML = '';
        this.removeClass();
      } catch (e) {}
    }
  }

  render () {
    return null;
  }
}

AdFoxWideScreen.propTypes = {
  regionName: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  dealType: PropTypes.string,
  realtyType: PropTypes.string
};
AdFoxWideScreen.defaultProps = {};

export default AdFoxWideScreen;



// WEBPACK FOOTER //
// ./src/ui/Widgets/AdFoxWideScreen.jsx